import { ColDef } from 'ag-grid-community';

export const FFLManagementColumnDef: ColDef[] = [
  {
    // ID
    headerName: ' ID',
    field: 'id',
    resizable: true,
    width: 135,
    filter: 'agTextColumnFilter',
    hide: true
  },
  {
    // FFL ID
    headerName: 'FFL',
    field: 'ffl',
    resizable: true,
    width: 190,
    filter: 'agTextColumnFilter',
    //hide: true
  },
  {
    // FFL Legal Name
    headerName: 'FFL Legal Name',
    field: 'legal_name',
    resizable: true,
    width: 275,
    tooltipField: 'ffl_legal_name',
    filter: 'agTextColumnFilter',
  },
  {
    // FFL Business Name
    headerName: 'FFL Business Name',
    field: 'business_name',
    resizable: true,
    width: 275,
    tooltipField: 'ffl_business_name',
    filter: 'agTextColumnFilter',
  },
  {
    // FFL Expiration Date
    headerName: 'FFL Expiration Date',
    field: 'expiration_date',
    resizable: true,
    width: 175,
    tooltipField: 'ffl_expiration_date',
    filter: 'agTextColumnFilter',
    cellRenderer: (params) => {
      const expirationDate = new Date(params.value);
      const currentDate = new Date();
      const isExpired = expirationDate < currentDate;
      const color = isExpired ? 'indianred' : 'white';
      return `<span style="color: ${color}">${params.value}</span>`;
    },
  },
  {
    // Phone Number
    headerName: 'Phone Number',
    field: 'phone_number',
    resizable: true,
    width: 150,
    tooltipField: 'phone_number',
    filter: 'agTextColumnFilter',
    hide: false
  },
  {
    // Email
    headerName: 'Email',
    field: 'email',
    resizable: true,
    width: 300,
    filter: 'agTextColumnFilter',
    hide: false
  },
  {
    // Attachment
    headerName: 'Attachment',
    field: 'certified_ffl_blob_name',
    resizable: true,
    width: 120,
    filter: false,
    sortable: false,
    cellRenderer: (params) => {
      if (params.value) {
        return `<div class="d-flex justify-content-center align-items-center w-100 h-100"><i class="fa-solid fa-paperclip" style="cursor: pointer; color: #2399e5; font-size: 1.2em;"></i></div>`;
      }
      return '';
    },
    onCellClicked: (params) => {
      if (params.value && params.context.ConfigComponent) {
        params.context.ConfigComponent.viewAttachment(params.data.id);
      }
    }
  },
  {
    // Notes
    headerName: 'Notes',
    field: 'notes',
    resizable: true,
    minWidth: 300,
    width: 125,
    tooltipField: 'notes',
    filter: 'agTextColumnFilter',
    flex: 1,
  }
];
